interface LifetimeInsightsCardProps {
  storiesTunedInto: number;
  emotionalNotesCaptured: number;
  civicIdentityLifetime: {
    resonates: number;
    worried: number;
    curious: number;
  };
}

export default function LifetimeInsightsCard({
  storiesTunedInto,
  emotionalNotesCaptured,
}: LifetimeInsightsCardProps) {
  return (
    <div className="bg-[#181818] rounded-2xl border border-[#282828]" style={{ boxShadow: '0px 12px 28px 3px rgba(0, 0, 0, 0.52), 0px 2px 8px 1px rgba(0, 0, 0, 0.16), inset 0px 1px 1px rgba(255, 255, 255, 0.04), inset 0px -1px 2px rgba(0, 0, 0, 0.22)' }}>
      <div className="p-6">
        <h3 className="text-[14px] font-semibold text-[#F5F5F5] mb-1">
          Lifetime Civic Insights
        </h3>
        <p className="text-[11px] text-[#808080] mb-4" style={{ lineHeight: '1.5' }}>
          Long-view patterns from your full civicbeat journey.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="bg-[#111111] rounded-2xl p-5 border border-[#282828] flex flex-col items-center justify-center min-h-[110px]">
            <div className="text-[32px] font-bold text-[#40E0D0] mb-1">
              {storiesTunedInto}
            </div>
            <div className="text-[13px] text-[#F5F5F5] text-center font-medium mb-0.5">
              Stories You've Tuned Into
            </div>
            <div className="text-[11px] text-[#808080] text-center">
              You return to the stories that matter
            </div>
          </div>

          <div className="bg-[#111111] rounded-2xl p-5 border border-[#282828] flex flex-col items-center justify-center min-h-[110px]">
            <div className="text-[32px] font-bold text-[#40E0D0] mb-1">
              {emotionalNotesCaptured}
            </div>
            <div className="text-[13px] text-[#F5F5F5] text-center font-medium mb-0.5">
              Emotional Moments Captured
            </div>
            <div className="text-[11px] text-[#808080] text-center">
              Stories that stirred something in you
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
